module.exports = "pegasus/assets/themelp1/webinar/103.png";